import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Loader from 'ui/Loader/Loader';
import DashboardCard from 'ui/DashboardCard/DashboardCard';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import Tabs from 'ui/Tabs/Tabs';
import MobileSubtitle from 'ui/MobileSubtitle/MobileSubtitle';
import { WarningModal } from 'components/modals';
import { TabsType } from './pendingRequest.model';
import PendingRequestTransfers from './tabs/Transfers/PendingRequestTransfers';
import PendingBillsPayment from './tabs/BillsPayment/BillsPayment';
import PendingRequestMobileMoney from './tabs/MobileMoney/PendingRequest';
import PendingRequestPrepaidCard from './tabs/PrepaidCardLoad/PendingRequest';
import PendingFXTransfer from './tabs/FXTransfer/FXPendingTransfer';

const tabsOptions = [
  { label: 'Transfers' },
  { label: 'Mobile Money' },
  { label: 'Prepaid Card Load' },
  { label: 'Bill Payments' },
  { label: 'FX Transfer Request' },
];

const PendingRequest = () => {
  const [activeTab, setActiveTab] = useState<TabsType>(0);
  const [nextTab, setNextTab] = useState<TabsType>(0);
  const [loadingData, setLoadingData] = useState(false);

  const [isFormDirty, setFormDirty] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

  const location = useLocation<{ tab: TabsType }>();

  useEffect(() => {
    if (downMdScreen) {
      setActiveTab(false);
    } else {
      setActiveTab(nextTab);
    }
    if (location.state) {
      setActiveTab(location.state.tab);
      // to be removed soon
      setLoadingData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downMdScreen]);

  const handleOnChangeTab = (_event: React.ChangeEvent<unknown>, tabIndex: TabsType) => {
    setNextTab(tabIndex);

    if (isFormDirty) {
      setShowWarning(true);
    } else {
      setActiveTab(tabIndex);
    }
  };

  const handleClickBack = () => {
    if (isFormDirty) {
      setShowWarning(true);
    } else {
      setActiveTab(false);
    }
  };

  const onLeavePage = () => {
    setShowWarning(false);
    setFormDirty(false);
    if (downMdScreen) {
      setActiveTab(false);
    } else {
      setActiveTab(nextTab);
    }
  };

  const closeWarning = () => setShowWarning(false);
  //   const switchDirtyTrue = () => setFormDirty(true);

  return (
    <DashboardCard fullHeight>
      <NavigationTitle
        to="/pendingRequests"
        layoutType={LayoutType.dashboard}
        onClick={handleClickBack}
        noArrow={activeTab === false}
      >
        {activeTab === false || !downMdScreen ? 'Pending Requests' : tabsOptions[activeTab].label}
      </NavigationTitle>
      {downMdScreen && activeTab === false && <MobileSubtitle>Select category</MobileSubtitle>}
      <Tabs value={activeTab} options={tabsOptions} onChange={handleOnChangeTab} />
      {loadingData ? <Loader /> : null}
      {!loadingData && activeTab === 0 && <PendingRequestTransfers />}
      {!loadingData && activeTab === 1 && <PendingRequestMobileMoney />}
      {!loadingData && activeTab === 2 && <PendingRequestPrepaidCard />}
      {!loadingData && activeTab === 3 && <PendingBillsPayment />}
      {!loadingData && activeTab === 4 && <PendingFXTransfer />}

      <WarningModal open={showWarning} submitName="Leave Page" onSubmit={onLeavePage} onClose={closeWarning}>
        Entered data will be lost. Are you sure you want to leave page?
      </WarningModal>
    </DashboardCard>
  );
};

export default observer(PendingRequest);
